import $http from '@/config/request';

//资源详情信息
export const detailInfo = params => {
  return $http.get(`/resource/rsc-info/detail?rscID=${ params.rscID }&userNo=${ params.userNo }`);
};

//作者简介
export const authorInfo = params => {
  return $http.post('/resource/common/rsc/user-info', params);
};

//其他相关资源
export const otherResourceRecommend = params => {
  return $http.get(`/resource/rsc-info/recommend/rscs?userNo=${ params.userNo }`);
};

//相关视频
export const videoRecommend = params => {
  return $http.get(`/resource/rsc-info/already/associate/rscs?rscID=${ params.rscID }&rscFileType=${ params.rscFileType }`);
};

//专题推荐
export const specialRecommend = rscID => {
  return $http.get(`/resource/rsc-pack/recommend/packs?rscID=${ rscID }`);
};

//专题推荐详情
export const recommendDetail = (params) => {
  return $http.get(`/resource/rsc-pack/recommend/packInfoList?packID=${ params.packID }`);
};

//购买
export const buy = params => {
  return $http.post('/resource/rsc-info/buyRscInfo', params);
};

//收藏
export const collect = params => {
  return $http.post('/resource/rsc-info/collectRscInfo', params);
};

//取消收藏
export const cancelCollect = params => {
  return $http.post('/resource/rsc-info/getOffColRscInfo', params);
};

//知识点列表
export const getPointList = params => {
  return $http.post('/resource/rsc-info/getPartsInfo', params);
};

//删除知识点
export const deletePoint = params => {
  return $http.post('/resource/user-group/del/part', params);
};

//标记知识点
export const markPoint = params => {
  return $http.post('/resource/user-group/add/part', params);
};

//获取已有知识单
export const ownknowledge = userNo => {
  return $http.get(`/resource/user-group/lists?userNo=${ userNo }`);
};

//知识点加入知识单
export const joinKnowledge = params => {
  return $http.post('/resource/user-group/bind/part', params);
};

//下载文档
export const download = params => {
  return $http.post('/resource/rsc-info/getRscPath', params);
};
